<template>
	<inertia-head title="Project Abundance" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Project Abundance</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Formerly known as Wealth Strategies
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div v-if="$page.props.user.current_rank === 'SILVER'" class="content">
		<div class="alert alert-warning">
			<p class="mb-0 fw-semibold">UPGRADE TO GOLD or HIGHER.</p>
		</div>
	</div>
	<div v-else class="content mt-5">
		<button
			@click="
				$inertia.visit(route('member.newsletter.wealth_strategies'), {
					preserveScroll: false,
				})
			"
			id="scroll_top"
			class="btn btn-secondary opacity-75 d-none"
		>
			<i class="fa fa-arrow-up"></i>
		</button>
		<p class="text-muted fs-sm">
			A brief to the point and applicable lifechanging principles and practical
			“action plans” on how to grow in your financial life. Covers everything
			from the universal principles of abundance, to the nitty-gritty stuff,
			like where to invest and grow your money, to how to protect your wealth
		</p>
		<div v-if="materials && materials.data.length > 0" class="row g-xxl-5 items-push pb-4">
			<div v-for="material in userMaterials.data" :key="material.id" class="col-md-4 mt-4" >
				<div class="pb-4 mb-4 border bg-white shadow" :set="bg_rand=Math.floor(Math.random() * 5)">
					<div class="p-1" :class="['bg-op-primary','bg-op-success','bg-op-warning','bg-op-info','bg-op-danger'][bg_rand]">
						<!-- <div
							class="overflow-hidden rounded mb-3 text-center"
							:class="['bg-op-primary','bg-op-success','bg-op-warning','bg-op-info','bg-op-danger'][bg_rand]"
							:style="'background-image:url(' + material.card + ')'"
							style="
								height: 240px;
								background-size: contain;
								background-position: center;
								background-repeat: no-repeat;
								background-blend-mode:color-burn;
							"
						></div> -->
						<img :src="material.card" style="width: 100%;height: auto;"/>
					</div>
					<div class="p-3 pt-0" style="height: 110px;">
						<p class="mb-1 text-center fs-sm">{{ material.title }}</p>
						<div class="fs-sm fw-medium text-muted mb-2 text-center">
							<span class="me-3 fs-xs">
								<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
								{{ material.date_created }}
							</span>
							<span class="fs-xs">
								<i class="fa fa-fw fa-tag opacity-50 me-1"></i>
								Project Abundance
							</span>
						</div>
						<p v-if="material.message" v-html="material.message" class="fs-sm mb-2"></p>
					</div>
					<div class="space-x-1 text-center">
						<a
							v-if="material.pdf"
							:href="'/member/download/user-materials/pdf/' + material.pdf + '?module=project-abundance'" target="_blank"
							class="btn btn-alt-primary btn-sm"
						>
							<i class="fa fa-cloud-download-alt me-1"></i>
							Download
						</a>
						<button
							v-if="material.video_id"
							type="button"
							class="btn btn-alt-info btn-sm"
						>
							Watch Video
						</button>
					</div>
				</div>
			</div>
			<nav class="d-flex justify-content-between align-items-center push">
				<inertia-link
					v-if="materials.prev_page_url"
					:href="materials.prev_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !materials.prev_page_url }"
				>
					<i class="fa fa-arrow-left opacity-50 me-1"></i>
					<span>Prev</span>
				</inertia-link>
				<inertia-link
					v-if="materials.next_page_url"
					:href="materials.next_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !materials.next_page_url }"
				>
					<span>Next</span>
					<i class="fa fa-arrow-right opacity-50 ms-1"></i>
				</inertia-link>
			</nav>
			<hr class="d-xl-none" />
		</div>
		<div v-else class="alert alert-warning">
			<p class="mb-0 fw-semibold">NO MATERIALS FOUND.</p>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import axios from 'axios'
import { debounce } from 'lodash'
import { onMounted, ref } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		materials: Object,
	},
	setup(props) {
		const userMaterials = ref(props.materials);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		return {
			userMaterials,
		}
	},
}
</script>
